import React, { useState } from 'react'
import { Box } from '@material-ui/core'

import { Container, LoadingFeedback, Page } from 'components'
import { Header } from './components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

const AssetInventoryReport = () => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const handleGenerateReport = async () => {
    try {
      setLoading(true)

      const response = await service.dponet.assetInventory.report()

      snackbar.open({
        message: response?.data?.message || 'Exportação realizada com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro ao realizar a exportação dos inventários de ativos.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Page title="Relatório de Inventário de Ativos">
      <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
        <Box py={5}>
          <LoadingFeedback open={loading} />
          <Header
            title="Relatório de Inventário de Ativos"
            description={
              'Gera um relatório consolidado do inventário de ativos da empresa, ' +
              'incluindo categorias, campos customizados, datas de criação e atualização. ' +
              'Este relatório auxilia na identificação e documentação de todos os ativos ' +
              'que processam ou armazenam dados pessoais, facilitando a conformidade ' +
              'com o Art. 37 da LGPD (mapeamento de tratamento de dados) ' +
              'e fornecendo uma visão completa dos recursos tecnológicos e físicos ' +
              'envolvidos no ciclo de vida dos dados.'
            }
            buttonType="button"
            buttonAction={handleGenerateReport}
          />
        </Box>
      </Container>
    </Page>
  )
}

export default AssetInventoryReport
